import { render } from "./CharacterAIBotSettings.vue?vue&type=template&id=38718633"
import script from "./CharacterAIBotSettings.vue?vue&type=script&lang=js"
export * from "./CharacterAIBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__